import { render, staticRenderFns } from "./ShopProductDetail.vue?vue&type=template&id=d43db50a&scoped=true&"
import script from "./ShopProductDetail.vue?vue&type=script&lang=js&"
export * from "./ShopProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShopProductDetail.vue?vue&type=style&index=0&id=d43db50a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d43db50a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VImg,VLayout})
